import { render, staticRenderFns } from "./icon-textbox.vue?vue&type=template&id=b0e4e7d0&"
import script from "./icon-textbox.vue?vue&type=script&lang=js&"
export * from "./icon-textbox.vue?vue&type=script&lang=js&"
import style0 from "./icon-textbox.vue?vue&type=style&index=0&id=b0e4e7d0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports